import DateTimeHelper from "../Helper/DateTimeHelper";

export default class KsUtility {
  public static GetValueByKey(data: unknown, searchKey: string): unknown {
    if (data === null || typeof data !== 'object') {
      return undefined;
    }
    var value = (data as Record<string, unknown>)[searchKey];

    var searchIndex = searchKey.indexOf(".");
    if (searchIndex !== -1) {
      var tempColumnName = searchKey.substring(0, searchIndex);
      var restColumnName = searchKey.substring(searchIndex + 1);
      value = (data as Record<string, unknown>)[tempColumnName];
      return KsUtility.GetValueByKey(value, restColumnName);
    }
    return value;
  }

  public static IsNullOrEmpty(data: string | undefined | null): boolean {
    return data === undefined || data === null || data === "";
  }

  public static GetValueIfNotNull<T>(data: T | null | undefined | "", replaceValue: T): T {
    if (data === undefined || data === null || data === "") {
      return replaceValue;
    }

    return data;
  }

  public static ToDdMmmYyyy(date: Date | string | undefined): string {
    return DateTimeHelper.ToDdMmmYyyy(date);
  }
  public static ToMmmmYyyy(date: Date | string | undefined): string {
    return DateTimeHelper.ToMmmmYyyy(date);
  }
  public static ToMonthNameMmmm(date: Date | string | undefined): string {
    return DateTimeHelper.ToMonthNameMmmm(date);
  }

  public static ToDdMmmYyyyHhMmssAmPm(date: Date | string | undefined): string {
    return DateTimeHelper.ToDdMmmYyyyHhMmssAmPm(date);
  }
  public static ToIstDdMmmYyyyHhMmssAmPm(date: Date | string | undefined): string {
    return DateTimeHelper.ToIstDdMmmYyyyHhMmssAmPm(date);
  }
  public static InputDateFormater(date: Date | undefined) {
    return DateTimeHelper.InputDateFormater(date);
  }
  public static ParseISO(date: Date | string | undefined): Date | null {
    return DateTimeHelper.ParseISO(date);
  }
  public static flattenMessages(nestedMessages: Record<string, unknown>, prefix = ''): Record<string, string> {
    return Object.keys(nestedMessages).reduce<Record<string, string>>((messages, key) => {
      let value = nestedMessages[key]
      let prefixedKey = prefix ? `${prefix}.${key}` : key

      if (typeof value === 'string') {
        //@ts-ignore
        messages[prefixedKey] = value
      } else if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
        Object.assign(messages, KsUtility.flattenMessages(value as Record<string, unknown>, prefixedKey))
      }

      return messages
    }, {})
  }
}
